var map = {
	"./app/components/BaseMapSelector/i18n.tsx": 473,
	"./app/components/Breadcrumb/i18n.tsx": 474,
	"./app/components/CountrySelect/i18n.tsx": 877,
	"./app/components/Drawer/i18n.tsx": 475,
	"./app/components/MapToggle/i18n.tsx": 476,
	"./app/components/Navbar/i18n.tsx": 878,
	"./app/components/PublicationBadge/i18n.tsx": 477,
	"./app/components/StageProgress/i18n.tsx": 478,
	"./app/components/StatsSummary/i18n.tsx": 479,
	"./app/screens/Dashboard/screens/Projects/components/ProjectPopup/i18n.tsx": 879,
	"./app/screens/Dashboard/screens/Projects/screens/ProjectDetail/screens/TechnicalSheet/i18n.tsx": 880,
	"./app/screens/Dashboard/screens/ProjectsIIRSA/i18n.tsx": 480,
	"./app/screens/Dashboard/screens/ProjectsIIRSA/screens/Analytics/i18n.tsx": 481,
	"./app/screens/Dashboard/screens/ProjectsIIRSA/screens/ElementsMap/i18n.tsx": 881,
	"./app/screens/Dashboard/screens/ProjectsIIRSA/screens/ProjectDetail/i18n.tsx": 882,
	"./app/screens/Home/i18n.tsx": 259,
	"./app/screens/Login/i18n.tsx": 482,
	"./config/i18n.tsx": 275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 876;